import React from "react";
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Typography } from "@mui/material";

import Question from '../../components/Question';
import InfoCard from "../../components/InfoCard";

export default function AppointmentReturningThankYou(props) {

    return (
        <Question
            noBack={true}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title="Your follow-up appointment is confirmed."
            input={
                <>
                    <Typography variant="h6" fontWeight={400} mt={2} mb={1}>
                        What to Expect Next
                    </Typography>

                    <InfoCard
                        icon={NotificationsActiveIcon}
                        title="Appointment Reminders"
                        description={
                            <>
                                We know life is busy, so we'll send you a reminder via SMS and email{" "}
                                <strong>24 hours</strong> before your appointment, and a final reminder{" "}
                                <strong>15 minutes</strong> before it's time to join your video visit.
                            </>
                        } />

                    <InfoCard
                        icon={VideoCallIcon}
                        title="Video Visit"
                        description="Next, you'll have a dedicated 15-minute video call with one of our expert nurse practitioners. During this visit, they will review your personalized treatment plan in detail and answer any questions you have."
                    />


                    <InfoCard
                        icon={MedicalInformationIcon}
                        title="Dermatologist Review"
                        description="A board-certified dermatologist will personally review your information and photos to develop your customized treatment plan."
                    />
                </>
            }
            {...props}
        />
    );
}
